// Local
import DSRoutes from './ds-routes';


// Code
let RoutesContainer = DSRoutes;

export default RoutesContainer;